import { IDocumentTokenDto } from "@/models/document-token.entity";
import { SignatureQRTokenConfig } from "@/lib/signature-token.utils";
import { VuetifyMaterialColorEnum } from "@/lib/enum/vuetify-color.enum";
import { BaseTokenEntity } from "./base-token.entity";

export class QrSignatureTokenEntity extends BaseTokenEntity {
  static readonly token = "{{sign.qr}}";

  get tokenString() {
    return QrSignatureTokenEntity.token;
  }

  get colorHex() {
    return VuetifyMaterialColorEnum.BLUE_GREY_DARKEN_1;
  }

  get icon() {
    return "mdi-draw";
  }

  get color() {
    return "blue-grey darken-1";
  }

  get labelKey() {
    return "sign.fieldType.signatureQr";
  }

  get defaultSize() {
    return { w: 0.26, h: 0.12 };
  }

  get fixedSize() {
    return true;
  }

  validateConstraints(pageWidthMm?: number, pageHeightMm?: number) {
    const width = pageWidthMm ? SignatureQRTokenConfig.w / pageWidthMm : this.defaultSize.w;
    const height = pageHeightMm ? SignatureQRTokenConfig.h / pageHeightMm : this.defaultSize.h;
    this.centerBounds(width, height);
  }

  toDto(widthPx: number, heightPx: number): IDocumentTokenDto {
    return this.buildDto(widthPx, heightPx);
  }
}
